/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

const DEV_API = 'http://pbcloud-dev3.obreey-products.com/api/v1.0/';
const PROD_API = '/api/v1.0/';

angular
    .module('webReader', [
        'ngCookies',
        'ngResource',
        //'ui.router',
        'ui.bootstrap',
        'LocalStorageModule',
         'angularModalService'
    ])
    // 0.0.1 is replaced with ${pom.version} when the application is built
    .value('appVersion', '0.0.1')
    .constant('API_DEFAULT_URL', PROD_API)
    .constant('URL_SEPARATOR', '/')
    .constant('DOCUMENT_INFORMATION_PROCESSING_TIMEOUT', 3000)
    .constant('SCROLL_BUFFER_FACTOR', 40)
    .constant('CHAPTER_STATUS_CONTENT_LOADED', 1)
    .constant('CHAPTER_STATUS_PREPROCESSED', 2)
    .constant('CHAPTER_STATUS_CACHED', 3)
    .constant('CHAPTER_STATUS_SHOWN', 4)
    .constant('TRANSLATION_KEY', 'AIzaSyD_g_bxXRopTiuB9LBr8rL1iLJ5H8fHL6g')
    .run(["$rootScope", "appVersion", function ($rootScope, appVersion) {
        $rootScope.appVersion = appVersion.match(/\{version\}/) !== null ? 'development' : appVersion;
    }]);